import { Box, Card, Image, Text } from '@doist/marketist';
import cn from 'clsx';
import css from './icon-card.module.css';
import type { ReactNode } from 'react';
type IconCardProps = {
  title: string;
  subtitle: string;
  image: string;
  link: string;
  imageWidth?: number;
  imageHeight?: number;
};
function IconCard({
  title,
  subtitle,
  image,
  link,
  imageWidth = 132,
  imageHeight = 110
}: IconCardProps) {
  return <Card className={cn(css.iconCard, 'pb-16 md-pi-24 lg-pb-32')} data-sentry-element="Card" data-sentry-component="IconCard" data-sentry-source-file="icon-card.tsx">
            <Box data-sentry-element="Box" data-sentry-source-file="icon-card.tsx">
                <Image src={image} width={imageWidth} height={imageHeight} alt={''} data-sentry-element="Image" data-sentry-source-file="icon-card.tsx" />
            </Box>

            <Box className={css.textContainer} data-sentry-element="Box" data-sentry-source-file="icon-card.tsx">
                <Text size="minor-base" weight="medium" className="pbe-4" data-sentry-element="Text" data-sentry-source-file="icon-card.tsx">
                    <a className={css.link} href={link}>
                        {title}
                    </a>
                </Text>
                <Text size="body-xs" data-sentry-element="Text" data-sentry-source-file="icon-card.tsx">{subtitle}</Text>
            </Box>
        </Card>;
}
IconCard.Grid = function IconCardGrid({
  children
}: {
  children: ReactNode;
}) {
  return <Box className={css.grid}>{children}</Box>;
};
export { IconCard };